import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';

const ServerErrorPage = () => {
  const color = useColor();
  const { navigate } = useWorkspaceRouter();
  return (
    <Style a="center" j="center" d="column">
      <img src="/assets/logo-syncly.svg" width={54} height={54} alt="syncly" />
      <Space h="32px" />
      <Heading type="hero">500</Heading>
      <Space h="16px" />
      <Heading type="h2" color={color.gray700}>
        Something went wrong
      </Heading>
      <Space h="8px" />
      <Typo type="label1" color={color.gray600}>
        Please try again later or feel free to contact us if the problem
        persists.
      </Typo>
      <Space h="24px" />
      <Button
        variant={'outlined'}
        onClick={() => {
          navigate('/');
        }}
      >
        Go back to the workspace
      </Button>
    </Style>
  );
};

const Style = styled(Flex)`
  width: 100%;
  height: 100vh;
`;

export default ServerErrorPage;
